import CopyButton from "@/features/copy/copy-button";

interface ReferralInfoProps {
  telegramReferralLink: string;
  platformReferralLink: string;
  referralReward: string;
  referredUsers: number;
  referralRewards: string;
}

const ReferralInfo = ({
  telegramReferralLink,
  platformReferralLink,
  referralReward,
  referredUsers,
  referralRewards,
}: ReferralInfoProps) => {
  return (
    <>
      <div className="flex items-center gap-[0.3125rem]">
        <span className="text-white text-xs w-[7rem]">
          Telegram Referral Link:
        </span>
        <span className="text-white text-xs">{telegramReferralLink}</span>
        <CopyButton value={telegramReferralLink} />
      </div>

      <div className="flex items-center gap-[0.3125rem]">
        <span className="text-white text-xs w-[7rem]">
          Platform Referral Link:
        </span>
        <span className="text-white text-xs">{platformReferralLink}</span>
        <CopyButton value={platformReferralLink} />
      </div>

      <div className="flex items-center gap-[0.3125rem]">
        <span className="text-white text-xs w-[7rem]">Referral Reward:</span>
        <span className="text-white text-xs">{referralReward}</span>
      </div>

      <div className="flex items-center gap-[0.3125rem]">
        <span className="text-white text-xs w-[7rem]">Referred Users:</span>
        <span className="text-white text-xs">{referredUsers}</span>
      </div>

      <div className="flex items-center gap-[0.3125rem]">
        <span className="text-white text-xs w-[7rem]">Referral Rewards:</span>
        <span className="text-white text-xs">{referralRewards}</span>
      </div>
    </>
  );
};

export default ReferralInfo;
